export interface AdminOption {
  uuid: string;
  name: string;
}

export const ADMIN_OPTIONS: AdminOption[] = [
  { uuid: "c8ee184b-d8fb-4b62-ad3a-5a5e091239ee", name: "Occitanic" },
  { uuid: "e5a6a950-9ed9-463f-bb04-b1bc3a0d6bc3", name: "Intermarche" },
  { uuid: "1bb0a6c1-fbdb-46b4-bc32-1c814c567d4d", name: "TVC" },
  { uuid: "f0156468-de4c-4e17-8bde-55f3d546403e", name: "Sieur d'Arques" },
  { uuid: "07a869e0-66a5-4dc3-9daa-d6ba2ee402ba", name: "Hauller" },
  { uuid: "9775434f-156c-44c5-bfa2-28bf0e7f2f78", name: "Imprimerie des Pyrenees" },
  { uuid: "a2def734-491e-4284-8fe9-c1d9b2b6e786", name: "FDL" },
  { uuid: "98ba8d1c-2eb7-483e-8ff1-e4084a27e67b", name: "Colombe le Sec" },
  { uuid: "c7903712-3cb1-4db9-8506-3a8da92949ec", name: "Champagne Chanoine Freres" },
];

export const DEFAULT_ADMIN = ADMIN_OPTIONS[0]; // Occitanic
